import { hasPartnerDashboardAccess } from "helpers/auth";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { identifyPostHogUserByEmail } from "@Utils/posthog";
import customWindowLocation from "@Utils/customWindowLocation";
import stripModalHistoryMarkers from "@Components/Modal/stripModalHistoryMarkers";
import createInventoriesShortlist, {
  removeShortlistParamFromURL,
} from "@Pages/Search/components/SearchListItem/components/ShortListButton/helper";

const loginSuccess = async (data: any, loginType: any, nextRoute: any) => {
  identifyPostHogUserByEmail(data?.email, {
    funnel: "login",
    login_type: loginType,
    user_id: data?.id,
    name: data?.name,
    phone: data?.phone,
  });

  // Google Analytics
  gtagEventEmitter({
    action: "success",
    category: "login",
    label: loginType,
    email_id: data?.email,
  });

  if (typeof window !== "undefined") {
    // @ts-ignore
    if (data?.user_auth_token && window.wx && window.wx.miniProgram) {
      // Send user auth token to mini program after login
      // @ts-ignore
      window.wx.miniProgram.postMessage({
        data: [
          {
            type: "USER_AUTH_TOKEN",
            user_auth_token: data.user_auth_token,
            timestamp: Date.now(),
          },
        ],
      });
    }
    const isConnectRoute = window.location.pathname?.includes("/list");
    if (isConnectRoute) {
      (async () => {
        try {
          const userAuthToken = data?.user_auth_token;
          const isPartnerLoginSuccess = await hasPartnerDashboardAccess(
            userAuthToken,
            "api/v0/auth/providers/users",
          );
          if (isPartnerLoginSuccess) {
            gtagEventEmitter({
              action: isConnectRoute ? "provider_login_success" : "partner_login_success",
              category: "login",
              label: loginType,
              email_id: data?.email,
            });
          }
        } catch (error) {
          console.log("Error occured while checking partner dashboard access", error);
        }
      })();
    }

    // Handle pending shortlist before reload
    const shortlistQuery = new URLSearchParams(window.location.search).get("shortlist_inv");
    if (shortlistQuery) {
      try {
        await createInventoriesShortlist({
          url_path: "/api/v0/auth/users/inventories_shortlists/",
          data: {
            inventories_shortlist: { inventory_id: shortlistQuery },
          },
        });
      } catch (error) {
        console.log("Error shortlisting inventory after login:", error);
      }
      removeShortlistParamFromURL();
    }
  }

  // Mweb login is history-backed (`isHistoryPush`). OTP success then closes the
  // sheet, and useModal's unmount `goBack()` cancels this document request.
  // Strip the markers first so cleanup skips goBack — same as openCopilotFromModal.
  stripModalHistoryMarkers();

  // Redirect to route on login or reload to set the login cookie
  if (nextRoute) {
    customWindowLocation({ url: `${nextRoute}` });
  } else {
    window.location.reload();
  }
};

export default loginSuccess;
